import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let AsphaltWholePortionPreparationSection: React.FC<IWorksheetComponent> = () => {
  return (
    <PageSection heading="Sieve Portion Preparation">
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.DryMass" />
      </ListFieldSection>
    </PageSection>
  );
};

AsphaltWholePortionPreparationSection = withInjectedProps(AsphaltWholePortionPreparationSection);

export { AsphaltWholePortionPreparationSection };
export default AsphaltWholePortionPreparationSection;
